<template>
    <div id="loading">
        <a-drawer
                :title="titleValue"
                :visible="loadingVis"
                @close="onCloseLoading"
                :zIndex="90"
                width="95%"
        >
            <a-row style="margin-top: 10px;">
                <a-button  ref="container" style="margin:0 10px" size="small" @click="componeTargetTo(0)" :class="activeBtn == 0 ? 'active-btn-primary':'' ">{{ $t('pubGicSet.CartonToContainer') }}</a-button>
                <a-button v-if="showButton" ref="pallet" style="margin:0 10px" size="small" @click="componeTargetTo(1)" :class="activeBtn == 1 ? 'active-btn-primary':'' ">{{ $t('pubGicSet.CartonToPallet') }}</a-button>
                <a-button v-if="showButton"  ref="palletContainer" style="margin:0 10px" size="small" @click="componeTargetTo(2)" :class="activeBtn == 2 ? 'active-btn-primary':'' ">{{ $t('pubGicSet.PalletToContainer') }}</a-button>
            </a-row>
            <a-divider dashed  style="margin: 10px 0"/>
            <a-row style="margin-top: 10px;">
                <component :btnFunArr="btnFunArr" :fieldMap="fieldMap" :is="currentView" v-on:subError="getError" v-on:palletToConFlag="getPalletToConFlag" :uid="uid"  :key="timer"></component>
            </a-row>
        </a-drawer>
        <a-modal
                :title="$t('pubGicSet.Error')"
                v-model="SkuExistVis"
                width="40%"
                @cancel="handleCancelSkuTishi"
                :footer="null"
        >
            <audio
                    controls="controls"
                    autoplay="autoplay"
                    loop="loop"
                    id="musicSKU"
                    hidden
            >
                <source src="../../../assets/mm.mp3" type="audio/mpeg" />
            </audio>

            <a-alert type="error">
                <p
                        slot="description"
                        style="color: red;font-size: 30px;padding: 50px 0;text-align: center;"
                >
                    {{scanInTishiInfo}}
                </p>
            </a-alert>
        </a-modal>
    </div>
</template>
<script>
    import cartonToContainer from './loading/loadingCartonToCon.vue'
    import cartontoPallet from './loading/loadingCartonTopallet.vue'
    import pallettoContainer from './loading/loadingPalletTocan.vue'
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import {mapState} from "vuex";
    export default{
        data(){
            return {
                activeBtn: 0,
                loadingVis: false,
                currentView: cartonToContainer,
                SkuExistVis: false,
                scanInTishiInfo: '',
                pallteChecked: true,
                uid:'',
                timer: '',
                titleValue:"",
                showButton:true,
                btnFunArr: [
                    {code: 'CTC-Print',arr:[]},
                    {code: 'CTC-Save',arr:[]},
                    {code: 'CTC-NewContainer',arr:[]},
                    {code: 'CTC-CartonByWave',arr:[]},
                    {code: 'CTC-ImportSSCC',arr:[]},
                    {code: 'CTP-NewPallet',arr:[]},
                    {code: 'CTP-Delete',arr:[]},
                    {code: 'PTC-NewContainer',arr:[]}
                ],
                fieldMap:{
                    ctcCarton: {},
                    ctcContainer: {},
                    ctcContainerType: {},
                    ctcDriver: {},
                    ctcEdiSendtime1: {},
                    ctcEdiSendtime2: {},
                    ctcEdiSendtime3: {},
                    ctcEdiSendtime4: {},
                    ctcEdiSendtime5: {},
                    ctcEta: {},
                    ctcEtd: {},
                    ctcHbl: {},
                    ctcHidden: {},
                    ctcHudf1: {},
                    ctcHudf2: {},
                    ctcHudf3: {},
                    ctcHudf4: {},
                    ctcHudf5: {},
                    ctcLoadFrom: {},
                    ctcLoadId: {},
                    ctcLoadTo: {},
                    ctcLoadedCartonQty: {},
                    ctcLogisticsid: {},
                    ctcMbl: {},
                    ctcPackId: {},
                    ctcPortOfDestination: {},
                    ctcPortOfDischarge: {},
                    ctcPortOfLoading: {},
                    ctcRelId: {},
                    ctcRemarks: {},
                    ctcRemove: {},
                    ctcSeal: {},
                    ctcSkuQty: {},
                    ctcSscc: {},
                    ctcTrackingNo: {},
                    ctcVesselFight: {},
                    ctcVoyage: {},
                    ctpCarton: {},
                    ctpCbm: {},
                    ctpHeight: {},
                    ctpLength: {},
                    ctpLoadedCartonQty: {},
                    ctpPackId: {},
                    ctpPalletNo: {},
                    ctpRelId: {},
                    ctpRmCartonFmContainer: {},
                    ctpSkuQty: {},
                    ctpTbTrackingNo: {},
                    ctpTrackingNo: {},
                    ctpWeightPallet: {},
                    ctpWeightUom: {},
                    ctpWidth: {},
                    ptcCarton: {},
                    ptcContainerNo: {},
                    ptcLoadedPalletQty: {},
                    ptcPackId: {},
                    ptcPalletNo: {},
                    ptcRelId: {},
                    ptcRmPalletFmContainer: {},
                    ptcSkuQty: {},
                    ptcTrackingNo: {}
                }
            }
        },
        computed: {
            ...mapState(["systemParam"])
        },
        methods:{
            loadingShow(uid){
                let params = {
                    module_code:"SCAN_LOADING"
                }
                ajax.get(api.GENERICPRINTNODEALLBTNFORLOAD,params).then(res=>{
                    this.fieldMap = res.data.fieldMap;
                    let btnMap = res.data.behrMap;

                    if (btnMap != null ) {
                        // 遍历 Map，判断值是否为 null
                        for (let key in  btnMap) {
                            if (btnMap[key] !== null) {
                                for(let i in this.btnFunArr){
                                    if(this.btnFunArr[i].code == key){
                                        this.btnFunArr[i].arr = btnMap[key];
                                    }
                                }
                            }
                        }
                    }
                })
                this.loadingVis = true
                this.uid = uid;
                this.timer = new Date().getTime();
                this.init();
            },
            init() {
                let params = {
                    uid: this.uid
                }
                let  LOAD_HIDE_SUBPAGES =  this.systemParam.LOAD_HIDE_SUBPAGES  == undefined ? 'N' : this.systemParam.LOAD_HIDE_SUBPAGES;
                if(LOAD_HIDE_SUBPAGES=='Y'){
                    this.showButton=false;
                }

                ajax.get(api.LOADINGGETLOADBYUID,params).then(res=>{
                    if(res.code == 200){
                        this.titleValue = this.$t('publicLang.Loading')+" （"+res.data.loadId+"）";
                    }
                })
            },
            componeTargetTo(type){
                this.activeBtn = type;
                if(type == 0){
                    this.currentView = cartonToContainer
                } else if(type == 1){
                    this.currentView = cartontoPallet
                } else{
                    this.currentView = pallettoContainer;
                }
            },
            onCloseLoading(){
                this.loadingVis = false
            },
            //            退出
            handleCancelSkuTishi(){
                this.audioPubFun();
                this.SkuExistVis = false

            },
            //            播放提示声
            audioPubFun() {
                let audio = document.getElementById("musicSKU");
                if (audio !== null) {
                    if (audio.paused) {
                        audio.play();
                    } else {
                        audio.pause();
                    }
                }
            },
            getPalletToConFlag(val){
                this.pallteChecked = val
            },
//            错误提示
            getError(val){
                this.audioPubFun();
                this.SkuExistVis = true
                this.scanInTishiInfo = val
            }
        }
    }
</script>

<style scoped>
    .active-btn-primary{
        color: #fff;
        background-color: #2b9ed6;
        border-color: #2b9ed6;
        text-shadow: 0 -1px 0 rgba(0, 0, 0, .12);
        -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, .045);
        box-shadow: 0 2px 0 rgba(0, 0, 0, .045);
    }

</style>